import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Text } from "@fluentui/react";
import { MainLayout } from "../../components/main-layout/main-layout";
import { k } from "./home-page-i18n";
export const HomePage = () => {
    const { t } = useTranslation();
    return (_jsx(MainLayout, { title: t(k.pageTitle), children: _jsx(Text, { children: t(k.message) }) }));
};
